"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionViewTimeline = void 0;
var react_1 = __importDefault(require("react"));
var luxon_1 = require("luxon");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var Timeline_1 = require("Analytics/Page/Components/Timeline");
var UsePageInteractions_1 = require("../UsePageInteractions");
var PageAcceptedTimelineCards_1 = require("Analytics/Page/Components/PageAcceptedTimelineCards");
var commonStyles = __importStar(require("Analytics/Page/CommonStyles.css"));
var styles = __importStar(require("./SessionViewTimeline.css"));
var SessionViewTimeline = function (_a) {
    var timeZone = _a.timeZone, pageId = _a.pageId, viewId = _a.viewId, sessionTimestamp = _a.sessionTimestamp;
    var isRecentSession = Date.now() - sessionTimestamp.getTime() < luxon_1.Duration.fromObject({ hours: 1 }).toMillis();
    var pageInteractions = (0, UsePageInteractions_1.usePageInteractions)({
        pageId: pageId,
        viewId: viewId,
        dedupingInterval: isRecentSession ? 5000 : 30000,
    }).pageInteractions;
    var _b = (0, Timeline_1.useTimeline)({
        timelineData: withSessionStartedEvent(pageInteractions, sessionTimestamp),
        timeZone: timeZone,
        renderEventCard: function (item) { return renderEventCard(item, timeZone); },
        getEventIcon: getEventIcon,
    }), timelineComponent = _b.timelineComponent, timelineFilterButtons = _b.timelineFilterButtons;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { className: "".concat(commonStyles.largeTabbedCard, " ").concat(styles.timelineCard) },
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", justify: "spaceBetween", align: "center", paddingTop: "m", paddingBottom: "m", paddingLeft: "l", paddingRight: "l" },
            react_1.default.createElement(kaleidoscope_1.Heading, { strong: true, level: "4" }, "Timeline"),
            timelineFilterButtons),
        react_1.default.createElement("div", { className: styles.timelineContainer }, timelineComponent)));
};
exports.SessionViewTimeline = SessionViewTimeline;
function withSessionStartedEvent(pageInteractions, sessionTimestamp) {
    if (pageInteractions == undefined)
        return undefined;
    return __spreadArray(__spreadArray([], __read(pageInteractions), false), [
        {
            timeStamp: sessionTimestamp,
            eventData: { interactionName: "Session started" },
        },
    ], false);
}
function renderEventCard(pageInteraction, timeZone) {
    switch (pageInteraction.eventData.interactionName) {
        case "Page Accepted":
            return react_1.default.createElement(PageAcceptedTimelineCards_1.PageAcceptedTimelineCard, { interactionEventData: pageInteraction.eventData, timeZone: timeZone });
        case "Page Partially Accepted":
            return react_1.default.createElement(PageAcceptedTimelineCards_1.PagePartiallyAcceptedTimelineCard, { interactionEventData: pageInteraction.eventData, timeZone: timeZone });
    }
    var cardDetails = getSimpleCardDetails(pageInteraction);
    return react_1.default.createElement(SimpleInteractionCard, { heading: pageInteraction.eventData.interactionName, details: cardDetails });
}
function getSimpleCardDetails(_a) {
    var eventData = _a.eventData;
    var interactionName = eventData.interactionName;
    switch (interactionName) {
        case "Button Clicked":
            return [{ title: "Button text", value: eventData.buttonText }];
        case "Block Entered Viewport":
            return __spreadArray([
                { title: "Block number", value: eventData.blockIndex + 1 }
            ], __read((eventData.blockType ? [{ title: "Block type", value: eventData.blockType }] : [])), false);
        case "ROI Calculator Updated": {
            if (eventData.term) {
                return [
                    { title: "Term name", value: eventData.term.termName },
                    { title: "Term value", value: eventData.term.termValue },
                ];
            }
            else if (eventData.sliderValue != undefined) {
                return [{ title: "Slider value", value: eventData.sliderValue }];
            }
            return [];
        }
        case "Accordion Opened":
            return [{ title: "Accordion title", value: eventData.title }];
        case "Block Unfolded":
            return __spreadArray(__spreadArray([], __read((eventData.h1 ? [{ title: "H1 text", value: eventData.h1 }] : [])), false), __read((eventData.h2 ? [{ title: "H2 text", value: eventData.h2 }] : [])), false);
        case "Clicked Navigation Item":
            return [{ title: "Block", value: eventData.blockName }];
        case "Outbound Link Click":
            return [
                { title: "Link text", value: eventData.linkText },
                { title: "Link destination", value: react_1.default.createElement(kaleidoscope_1.Link, { href: eventData.linkUrl }, eventData.linkUrl) },
            ];
    }
    return [];
}
function getEventIcon(_a) {
    var eventData = _a.eventData;
    switch (eventData.interactionName) {
        case "Button Clicked":
            return react_1.default.createElement(icons_1.Button, { color: "default" });
        case "Block Entered Viewport":
            return react_1.default.createElement(icons_1.Blocks, { color: "default" });
        case "ROI Calculator Updated":
            return react_1.default.createElement(icons_1.WidgetRoi, null);
        case "Accordion Opened":
            return react_1.default.createElement(icons_1.AccordionLeftButton, { color: "default" });
        case "Block Unfolded":
            return react_1.default.createElement(icons_1.Button, { color: "default" });
        case "Clicked Navigation Item":
            return react_1.default.createElement(icons_1.Menu, { color: "default" });
        case "Outbound Link Click":
            return react_1.default.createElement(icons_1.Link, { color: "default" });
        case "Page Partially Accepted":
        case "Page Accepted":
            if (eventData.eSigned) {
                return react_1.default.createElement(icons_1.BlockAcceptEsign, null);
            }
            else {
                return react_1.default.createElement(icons_1.BlockAccept, null);
            }
        case "Session started":
            return react_1.default.createElement(icons_1.Preview, { color: "default" });
    }
}
var SimpleInteractionCard = function (_a) {
    var heading = _a.heading, _b = _a.details, details = _b === void 0 ? [] : _b;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "s" },
        react_1.default.createElement(kaleidoscope_1.Heading, { strong: true, level: "5", align: "left" }, heading),
        details.length > 0 && (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs" }, details.map(function (m, index) { return (react_1.default.createElement(kaleidoscope_1.Stack, { key: index, direction: "horizontal" },
            react_1.default.createElement(kaleidoscope_1.Text, { className: styles.cardDetailsTitle, strong: true, size: "xs", align: "left", element: "div" }, m.title),
            react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, m.value))); })))));
};
